import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getAddressTypes } from 'reducers/customerSearch';
import { AddressTypes } from 'types/Address';

import CompanyForm from './CompanyForm';
import PersonForm from './PersonForm';
import { ConfigurableForm } from './components';

const CustomerForm = ({
  onChange,
  customer,
  setFieldIsValid,
  configuration,
}) => {
  const { customerType } = customer ?? {};

  const handleChange = useCallback(
    event => {
      const { target } = event;
      const value =
        target.type === 'checkbox' ? Number(target.checked ?? 0) : target.value;
      const { name } = target;

      if (name === 'address') {
        const { addressID, addressFieldKey } = event;

        const newAddresses = customer.addresses;
        const addressIndex = newAddresses.findIndex(
          a => a.addressID === addressID,
        );

        const newAddress = {
          ...customer.newAddress,
          ...newAddresses[addressIndex], // if index is negative this does nothing
          [addressFieldKey]: value,
        };
        if (addressIndex >= 0) {
          newAddresses[addressIndex] = newAddress;
        }
        return onChange({
          newAddress,
          ...customer,
          [name]: newAddresses,
        });
      }
      return onChange({
        ...customer,
        [name]: value,
      });
    },
    [customer],
  );

  const addressTypes: AddressTypes[] = useSelector(getAddressTypes);
  useEffect(() => {
    if (addressTypes?.[0]?.id && !customer.addressTypeID) {
      onChange({ ...customer, addressTypeID: addressTypes[0].id });
    }
  }, [addressTypes, customer.addressTypeID]);

  return (
    <ConfigurableForm
      config={configuration.formFields?.[customer.customerType]}
      setFieldIsValid={setFieldIsValid}
    >
      {customerType === 'COMPANY' ? (
        <CompanyForm
          customer={customer}
          handleChange={handleChange}
          onChange={onChange}
        />
      ) : (
        <PersonForm
          customer={customer}
          handleChange={handleChange}
          onChange={onChange}
        />
      )}
    </ConfigurableForm>
  );
};

export default CustomerForm;
